import { Badge } from '@/components/ui/badge'
import type { SupportTicket } from '@/types/entities'

export function TicketProductBadge({ ticket }: { ticket: Pick<SupportTicket, 'metadata'> }) {
  const context = ticket.metadata?.supportContext as { product?: string; basis?: string } | undefined
  const label = context?.product === 'memoryframe' ? 'MemoryFrame'
    : context?.product === 'marketplace' ? 'Arthaus Marketplace' : 'Product unconfirmed'
  return <Badge variant="outline" title={context?.basis === 'subject_hint' ? 'Customer-supplied product hint; not identity verification' : undefined}>{label}</Badge>
}
